import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=87b65fc2&scoped=true"
import script from "./nav-bar.vue?vue&type=script&lang=ts"
export * from "./nav-bar.vue?vue&type=script&lang=ts"
import style0 from "./nav-bar.vue?vue&type=style&index=0&id=87b65fc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b65fc2",
  null
  
)

export default component.exports